import { apiClient } from './config';

/**
 * Get all manovre
 */
export const getManovre = async () => {
  const response = await apiClient.get('/manovre');
  return response.data;
};

/**
 * Add new manovra
 */
export const addManovra = async (manovra) => {
  const response = await apiClient.post('/manovre', manovra);
  return response.data;
};

/**
 * Update existing manovra
 */
export const updateManovra = async (id, manovra) => {
  const response = await apiClient.put(`/manovre/${id}`, manovra);
  return response.data;
};

/**
 * Delete single manovra
 */
export const deleteManovra = async (id) => {
  const response = await apiClient.delete(`/manovre/${id}`);
  return response.data;
};

/**
 * Delete all manovre
 */
export const deleteAllManovre = async () => {
  const response = await apiClient.delete('/manovre');
  return response.data;
};

/**
 * Download workflow Excel file
 */
export const downloadWorkflowExcel = async () => {
  const response = await apiClient.get('/manovra/excel', {
    responseType: 'blob',
  });
  return response.data;
};
